import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type PreviewState = {
  previewMode: boolean;
  setPreviewMode: (mode: boolean) => void;
};

const usePreviewStore = create<PreviewState>()(
  persist(
    (set) => ({
      previewMode: false,
      setPreviewMode: (previewMode) => set({ previewMode }),
    }),
    {
      name: 'mesa-portal-preview',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default usePreviewStore;
